import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "button-bar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranslatedText = _resolveComponent("TranslatedText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "button-bar__button sort",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSort && _ctx.toggleSort(...args)))
    }, [
      _createVNode(_component_TranslatedText, { path: "common.sort" })
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "divider" }, null, -1)),
    _createElementVNode("button", {
      class: "button-bar__button filter",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleFilter && _ctx.toggleFilter(...args)))
    }, [
      _createVNode(_component_TranslatedText, { path: "filter.title" })
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "divider" }, null, -1)),
    _createElementVNode("button", {
      class: "button-bar__button search",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openSearch && _ctx.openSearch(...args)))
    }, [
      _createVNode(_component_TranslatedText, { path: "common.search" })
    ])
  ]))
}